import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useApplicationStoreActions, useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import { computed, defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
import { useI18n } from "vue-i18n-composable";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { formatAgentForAvatar } from "@Broker/js/custom/utils";
import { showToast } from "@Shared/@Utils/constants";
export default defineComponent({
  components: {
    ProfileAvatar
  },
  props: {
    currentData: {
      type: Object,
      default: () => ({})
    },
    showFavorites: {
      type: Boolean,
      default: false
    },
    showAllAgents: {
      type: Boolean,
      default: true
    },
    isSearching: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      currentData
    } = toRefs(props);
    const {
      showFavorites
    } = toRefs(props);
    const {
      showAllAgents
    } = toRefs(props);
    const {
      isSearching
    } = toRefs(props);
    const currentAgents = ref([]);
    const {
      t,
      tc
    } = useI18n();
    const table = ref(null);
    const {
      ADD_CO_BROKER_TO_FAVORITES_LIST,
      REMOVE_CO_BROKER_FROM_FAVORITES_LIST
    } = useApplicationStoreActions([LenderSubmitActions.ADD_CO_BROKER_TO_FAVORITES_LIST, LenderSubmitActions.REMOVE_CO_BROKER_FROM_FAVORITES_LIST]);
    const {
      LOAD_CO_BROKER_AGENTS
    } = useApplicationStoreActions([LenderSubmitActions.LOAD_CO_BROKER_AGENTS]);
    const {
      LOAD_CO_BROKER_FAVORITES
    } = useApplicationStoreActions([LenderSubmitActions.LOAD_CO_BROKER_FAVORITES]);
    const {
      CO_BROKERING_AGENTS_FULLY_LOADED
    } = useApplicationStoreGetters([LenderSubmitGetters.CO_BROKERING_AGENTS_FULLY_LOADED]);
    const MAX_COUNT = 9999999;
    const loadingMoreAgents = ref(false);
    const handleTableLoading = () => {
      loadingMoreAgents.value = true;
    };
    const handleTableLoaded = () => {
      loadingMoreAgents.value = false;
    };
    const isAgentSelected = row => {
      return currentData.value.agentSelected.agentUsername === row.agentUsername;
    };
    const handleSelectAgent = agent => {
      emit("agent-selected", agent);
    };
    const toggleFavoriteAgent = async row => {
      var _table$value;
      row.isFavorite ? await REMOVE_CO_BROKER_FROM_FAVORITES_LIST({
        usernameToUnfavorite: row.agentUsername
      }) : await ADD_CO_BROKER_TO_FAVORITES_LIST({
        usernameToFavorite: row.agentUsername
      });
      showToast("success", !row.isFavorite ? "coBrokerAddedToFavorites" : "coBrokerRemovedFromFavorites");
      (_table$value = table.value) == null ? void 0 : _table$value.refresh();
      return row;
    };
    const fullAddress = address => {
      const {
        fullAddress
      } = useAddress(address);
      return fullAddress.value;
    };
    const checkForFavorites = () => {
      if (currentAgents.value.length) {
        emit("display-show-favorites", favoritesAgents.value.length > 0);
      }
    };
    const favoritesAgents = computed(() => {
      var _context;
      return _filterInstanceProperty(_context = currentAgents.value).call(_context, agent => agent.isFavorite);
    });
    const tableRequestFunction = async tableOptions => {
      const tableData = {
        data: [],
        count: MAX_COUNT
      };
      const {
        page,
        limit
      } = tableOptions;
      const offset = (page - 1) * limit;
      if (CO_BROKERING_AGENTS_FULLY_LOADED.value) return tableData;
      const {
        agentFirstName,
        agentLastName,
        brokerageSelected
      } = currentData.value;
      const {
        agents
      } = isSearching.value ? await LOAD_CO_BROKER_AGENTS({
        agentFirstName,
        agentLastName,
        brokerageId: brokerageSelected.brokerageId,
        offset,
        limit
      }) : await LOAD_CO_BROKER_FAVORITES({
        offset,
        limit
      });
      currentAgents.value = agents;
      tableData.data = currentAgents.value;
      if (showAllAgents.value && showFavorites.value && isSearching.value) {
        tableData.data = favoritesAgents.value;
        emit("show-all-agents", false);
      } else if (showAllAgents.value && !showFavorites.value && !isSearching.value) {
        emit("clear-favorites");
      } else if (!showAllAgents.value && showFavorites.value) {
        tableData.data = favoritesAgents.value;
      } else if (!showAllAgents.value && !showFavorites.value) {
        var _context2;
        tableData.data = _filterInstanceProperty(_context2 = currentAgents.value).call(_context2, agent => !agent.isFavorite);
      }
      checkForFavorites();
      return tableData;
    };
    watch([showFavorites], () => {
      var _table$value2;
      (_table$value2 = table.value) == null ? void 0 : _table$value2.refresh();
    });
    const tableOptions = computed(() => {
      {
        return {
          columns: ["select", "name", "brokerage", "address", "favorite"],
          options: {
            filterable: false,
            sortable: [],
            headings: {
              select: t("application-form.select"),
              name: t("account.fullName"),
              brokerage: t("global.doorr.brokerage"),
              address: tc("global.words.address", 1),
              favorite: t("global.words.favorite")
            },
            perPage: 20,
            tabbable: false,
            skin: "table mb-0",
            columnsClasses: {
              select: "w-10 text-center hidden-heading",
              name: "w-30",
              brokerage: "w-30",
              favorite: "hidden-heading"
            },
            texts: {
              noResults: t("direct-to-lender.participants.noAgentsMatchYourSearch")
            },
            requestFunction: tableRequestFunction,
            stickyHeader: true,
            pagination: {
              virtual: true
            },
            rowAttributesCallback: row => {
              return isAgentSelected(row) ? {
                style: "background-color: var(--primary-1) !important"
              } : {
                style: "background-color: #ffffff !important"
              };
            }
          }
        };
      }
    });
    return {
      tableOptions,
      handleTableLoading,
      handleTableLoaded,
      isAgentSelected,
      handleSelectAgent,
      fullAddress,
      table,
      formatAgentForAvatar,
      toggleFavoriteAgent,
      currentAgents
    };
  }
});